import { cloneElement, ReactElement } from "react";

import { Button, Flex, Tag } from "@chakra-ui/react";

import { DetailL } from "ui/Typography/Typography";

interface TabButtonProps {
  onClick: () => void;
  isActive: boolean;
  icon: ReactElement<any>;
  label: string;
  count?: number;
  maxW: number;
  minW: number;
}

export function TabButton({ onClick, isActive, icon, label, count, maxW, minW }: TabButtonProps) {
  return (
    <Button
      variant="unstyled"
      onClick={onClick}
      display="flex"
      alignItems="center"
      justifyContent="flex-start"
      gap={count && count.toString().length >= 3 ? "s150" : "s100"}
      position="relative"
      maxW={`${maxW}px`}
      minW={`${minW}px`}
      whiteSpace="normal"
      wordBreak="break-word"
      h="36px"
      p="s100"
    >
      <Flex justify="center" align="center" w="24px" h="36px" position="relative" color="gray.800">
        {cloneElement(icon, {
          boxSize: 6,
        })}
        {count ? (
          <Tag
            size="sm"
            minH="16px"
            maxW="100%"
            lineHeight="1rem"
            pos="absolute"
            top="0px"
            right="10px"
            transform="translateX(100%)"
            bg="pinkFlink.500"
            color="white"
            borderRadius="100px"
            display="flex"
            alignItems="center"
            justifyContent="center"
            px="4px"
            whiteSpace="nowrap"
            fontWeight="bold"
          >
            {count}
          </Tag>
        ) : null}
      </Flex>
      <DetailL color="grey.800" fontWeight={isActive ? "bold" : "normal"}>
        {label}
      </DetailL>
    </Button>
  );
}
